import { render, staticRenderFns } from "./vehiclecheckviewdata.html?vue&type=template&id=64724c9b&scoped=true&external"
import script from "./vehiclecheckviewdata.vue?vue&type=script&lang=js"
export * from "./vehiclecheckviewdata.vue?vue&type=script&lang=js"
import style0 from "./vehiclecheckviewdata.vue?vue&type=style&index=0&id=64724c9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64724c9b",
  null
  
)

export default component.exports